export default __webpack_public_path__ + "static/media/iso_22001.a759bdf7.jpg";